import styled, { keyframes } from 'styled-components';

// Implementacao do design Clientes.html — hairline shell pattern:
// page-header + filters 4-col + table 5-col grid + pager.
// Mesmo padrao da relacao-variaveis (styled-variables.js) — variaveis
// CSS (var(--cco-*)) ao inves de theme.colors.X.

// ============================================================
// Container
// ============================================================
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 64px);
  min-height: 100vh;
  margin: 0 0 0 64px;
  padding: 0;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);

  @media (max-width: 720px) {
    width: 100vw;
    margin: 0;
  }
`;

// Wrapper kept como compat (modal de cadastro antigo pode usar).
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// ============================================================
// Page Header (.ph) — titulo + sub + contador "X clientes"
// ============================================================
export const PageHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const PageHeaderText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--cco-ink);
`;

export const PageSub = styled.div`
  color: var(--cco-ink-mute);
  font-size: 13px;
  margin-top: 3px;
`;

export const PageCount = styled.div`
  font-size: 13px;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;

  b {
    color: var(--cco-ink);
    font-weight: 700;
  }
`;

// ============================================================
// Filters (.filters) — grid 4-col com hairlines
// busca | status | empresa | CTA
// ============================================================
export const Filters = styled.section`
  display: grid;
  grid-template-columns: 1fr 220px 220px auto;
  border-bottom: 1px solid var(--cco-line);

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    > * {
      border-left: 0;
      border-top: 1px solid var(--cco-line);
    }
    > *:first-child,
    > *:nth-child(2) {
      border-top: 0;
    }
    > *:nth-child(odd) {
      border-right: 1px solid var(--cco-line);
    }
  }

  /* Mobile: tudo empilhado em 1 coluna, hairlines viram bottom-borders */
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    > * {
      border: 0 !important;
      border-bottom: 1px solid var(--cco-line) !important;
    }
    > *:last-child {
      border-bottom: 0 !important;
    }
  }
`;

// Search cell — lupa svg + input transparente
export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px var(--cco-pad);

  svg {
    color: var(--cco-ink-mute);
    flex: none;
    width: 16px;
    height: 16px;
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 14px;
    padding: 8px 0;
    min-width: 0;

    ::placeholder {
      color: var(--cco-ink-faint);
    }
  }
`;

// Sel cell — native select com seta SVG inline
export const SelCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px var(--cco-pad);

  .k {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--cco-ink-mute);
    flex: none;
  }

  select {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 13.5px;
    font-weight: 500;
    padding: 8px 22px 8px 0;
    appearance: none;
    cursor: pointer;
    width: 100%;
    min-width: 0;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='rgba(255,255,255,.4)' d='M0 0h12L6 8z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0 center;
  }

  select option {
    background: var(--cco-bg);
    color: var(--cco-ink);
  }
`;

// Cta button — pill cyan-soft com .ic + .tx (dual line)
export const Cta = styled.button.attrs({ className: 'cta' })`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: rgba(28, 176, 216, 0.1);
  color: var(--cco-cyan);
  border: 0;
  transition: background 150ms ease;
  cursor: pointer;
  min-width: 220px;
  font-family: inherit;

  @media (max-width: 720px) {
    min-width: 0;
    width: 100%;
    justify-content: flex-start;
  }

  :hover {
    background: rgba(28, 176, 216, 0.18);
  }

  .ic {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: var(--cco-cyan);
    color: #0a0a0b;
    display: grid;
    place-items: center;
    flex: none;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .tx {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.25;
  }
  .tx .t {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .tx .s {
    font-size: 11.5px;
    color: var(--cco-ink-mute);
    font-weight: 500;
  }
`;

// ============================================================
// Table (.table) — grid 5-col:
// Empresa | E-mail | Status | Ativacao | Editar
// ============================================================
export const TableWrap = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 100px minmax(200px, 1fr) 2fr 130px 150px 110px;
  align-items: stretch;

  /* Mobile: vira card layout (cada Tr empilha, Th some). */
  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Th = styled.div`
  padding: 14px var(--cco-pad);
  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  ${(props) => props.$center && 'justify-content: center;'}

  @media (max-width: 720px) {
    display: none;
  }
`;

// Tr — display:contents pra cada filho ir direto pro grid pai
export const Tr = styled.div`
  display: contents;

  :hover .tc {
    background: rgba(255, 255, 255, 0.02);
  }

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    padding: 14px var(--cco-pad);
    border-bottom: 1px solid var(--cco-line);
    gap: 4px;
  }
`;

export const Tc = styled.div.attrs({ className: 'tc' })`
  padding: 18px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  transition: background 120ms ease;
  min-width: 0;
  gap: 8px;
  ${(props) => props.$center && 'justify-content: center;'}

  @media (max-width: 720px) {
    padding: 4px 0;
    border-bottom: 0;
    justify-content: flex-start;
    &::before {
      content: attr(data-label);
      color: var(--cco-ink-mute);
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      margin-right: 8px;
      min-width: 70px;
      flex-shrink: 0;
    }
  }
`;

export const TcName = styled(Tc).attrs({ 'data-label': 'Empresa' })`
  font-weight: 700;
  color: var(--cco-ink);
  font-size: 14px;
  letter-spacing: 0.04em;
`;

export const TcEmail = styled(Tc).attrs({ 'data-label': 'E-mail' })`
  color: var(--cco-ink);
  font-size: 13.5px;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// === Coluna Tarifa (R$/kWh) — edicao inline ===
export const TcTariff = styled(Tc).attrs({ 'data-label': 'Tarifa' })`
  justify-content: center;
  gap: 6px;
`;

// Pill clicavel: mostra a tarifa ou "definir". Vira input ao clicar.
export const TariffPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid var(--cco-line);
  background: ${(props) =>
    props.$empty ? 'transparent' : 'var(--cco-soft-surface)'};
  color: ${(props) =>
    props.$empty ? 'var(--cco-ink-faint)' : 'var(--cco-ink)'};
  font-size: 12.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 150ms, color 150ms, background 150ms;

  &:hover {
    border-color: var(--cco-line-strong);
    color: var(--cco-ink);
  }
`;

export const TariffEditor = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const TariffInput = styled.input`
  width: 74px;
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid var(--cco-blue);
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  outline: none;
  text-align: right;

  &:focus {
    box-shadow: 0 0 0 2px var(--cco-blue-soft);
  }
`;

export const TariffIconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--cco-line);
  background: ${(props) =>
    props.$primary ? 'var(--cco-blue)' : 'transparent'};
  color: ${(props) => (props.$primary ? '#fff' : 'var(--cco-ink-mute)')};
  cursor: pointer;
  transition: filter 150ms, background 150ms, color 150ms;

  &:hover:not(:disabled) {
    ${(props) =>
      props.$primary
        ? 'filter: brightness(1.08);'
        : 'color: var(--cco-ink); border-color: var(--cco-line-strong);'}
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  > svg {
    width: 15px;
    height: 15px;
  }
`;

// Status pill (variante "dot + label") — verde quando ativo,
// cinza quando inativo. Diferente do StatusPill de Variaveis (la
// e uma pill solida); aqui o design original usa um indicador
// minimalista com bolinha.
export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: ${(props) => (props.$on ? 'var(--cco-green)' : 'var(--cco-ink-mute)')};

  ::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: ${(props) => (props.$on ? 'var(--cco-green)' : 'var(--cco-ink-faint, #5a6068)')};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.$on ? 'rgba(43, 212, 125, 0.18)' : 'rgba(90, 96, 104, 0.18)'};
  }
`;

// Toggle iOS-style: pill que alterna entre verde/cinza com
// circulo branco animado. Usado na coluna "Ativacao".
export const Toggle = styled.button`
  width: 42px;
  height: 22px;
  border-radius: 999px;
  border: 0;
  padding: 0;
  background: ${(props) =>
    props.$on ? 'var(--cco-green)' : 'rgba(255, 255, 255, 0.1)'};
  cursor: pointer;
  position: relative;
  transition: background 150ms ease;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.3);
  font-family: inherit;

  ::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${(props) => (props.$on ? '22px' : '2px')};
    width: 18px;
    height: 18px;
    border-radius: 999px;
    background: #fff;
    transition: left 150ms ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Row actions — container pra botoes de acao
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

// IconBtn — botao 36x32 com borda hairline (estilo .edit-btn do design).
// Versao mais sutil que o IconBtn de Variaveis pra combinar com o look
// minimalista de Clientes.
export const IconBtn = styled.button`
  width: 36px;
  height: 32px;
  /* Touch target >=44px no mobile (WCAG 2.5.5 / Apple HIG). */
  @media (max-width: 720px) {
    min-width: 44px;
    min-height: 44px;
  }
  border-radius: 8px;
  background: transparent;
  border: 1px solid var(--cco-line-strong);
  display: grid;
  place-items: center;
  color: var(--cco-ink-mute);
  transition: all 150ms ease;
  cursor: pointer;
  font-family: inherit;

  :hover:not(:disabled) {
    color: var(--cco-cyan);
    border-color: var(--cco-cyan);
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Empty row (full-width 5 colunas)
export const EmptyRow = styled.div`
  grid-column: 1 / -1;
  padding: 60px 0;
  text-align: center;
  color: var(--cco-ink-faint);
`;

// Skeleton row — mantem mesma celula visual mas com shimmer placeholder
const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonCell = styled(Tc)`
  ::before {
    content: '';
    display: block;
    width: ${(props) => props.$w || '70%'};
    height: 14px;
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0.04) 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
  }

  @media (max-width: 720px) {
    ::before {
      margin-right: 0;
      min-width: 0;
    }
  }
`;

// ============================================================
// Pager (.pager) — Anterior / 1 2 3 ... 45 46 47 / Proximo + exibir N
// ============================================================
export const Pager = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 20px var(--cco-pad);
  border-top: 1px solid var(--cco-line);
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 8px;
    padding: 14px var(--cco-pad);
    .btn {
      padding: 0 12px;
      font-size: 11.5px;
    }
    .pg {
      width: 32px;
      height: 32px;
      font-size: 12.5px;
    }
  }

  .btn {
    height: 36px;
    padding: 0 18px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 12.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
  }
  .btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .pages {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  .pg {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    display: grid;
    place-items: center;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13.5px;
    font-weight: 600;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .pg.on {
    background: var(--cco-cyan);
    border-color: var(--cco-cyan);
    color: #0a0a0b;
  }
  .pg:not(.on):hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .dots {
    color: var(--cco-ink-mute);
    padding: 0 4px;
    font-weight: 700;
  }
  .exhibit {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--cco-ink-mute);
    font-size: 12.5px;
  }
  .exhibit select {
    height: 32px;
    padding: 0 28px 0 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(255,255,255,.4)' d='M0 0h10L5 6z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 8px center;
    font-family: inherit;
  }
`;

// ============================================================
// Compat exports — caso outras telas/components antigos importem
// estes nomes (PaginationContainer, Label, ButtonCliente, etc).
// ============================================================
export const PaginationContainer = Pager;
export const Label = styled.span`
  font-size: ${(props) => props.size || '12.5px'};
  margin-left: ${(props) => props.marginleft || '0px'};
  color: ${(props) => props.color || 'var(--cco-ink-mute)'};
`;
export const ButtonCliente = Cta;
export const ButtonDiv = styled.div``;
export const IconNew = styled.img``;
export const LabelCadastro = styled.span``;
